<template>
  <a-drawer
    title="新建语种"
    width="800"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="handleCancel"
  >
    <!-- 表单数据 -->
    <a-form
      lang_name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 名称 -->
      <a-form-item
        label="名称"
        lang_name="lang_name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.lang_name" placeholder="请输入" />
      </a-form-item>
      <!-- 顺序 -->
      <a-form-item
        label="顺序"
        lang_name="sort"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.sort" placeholder="请输入" />
      </a-form-item>
      <!-- 前台名称 -->
      <a-form-item
        label="前台名称"
        lang_name="app_name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.app_name" placeholder="请输入" />
      </a-form-item>
      <!-- 自媒体翻译语速 -->
      <a-form-item
        label="自媒体翻译语速"
        lang_name="speech_speed"
      >
        <a-input v-model:value="formState.speech_speed" placeholder="请输入" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive } from 'vue'
import Loading from '@/components/Loading'
import { message } from 'ant-design-vue'
import { langAdd } from '@/api/admin'

// 注册父组件的事件
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// id
let id = ref(undefined)
// 表单数据
let formState = reactive({
  lang_name: undefined,
  sort: undefined,
  app_name: undefined,
  speech_speed: undefined
})
// 加载
let isLoading = ref(false)

// 展示弹窗
function showDrawer (data) {
  visible.value = true
  // 记录
  if (!!data) {
    id.value = data.id
    formState.lang_name = data.lang_name
    formState.sort = data.sort
    formState.app_name = data.app_name
    formState.speech_speed = data.speech_speed
  }
}

// 关闭弹窗
function handleCancel () {
  // 重置表单
  RefForm.value.resetFields()
  visible.value = false
  // 重置
  id.value = undefined
  formState.lang_name = undefined
  formState.sort = undefined
  formState.app_name = undefined
  formState.speech_speed = undefined
}

// 提交
function handleOk () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    langAdd({
      id: id.value,
      lang_name: formState.lang_name,
      sort: formState.sort,
      app_name: formState.app_name,
      speech_speed: formState.speech_speed
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        handleCancel()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>

</style>